import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "bg-gray-100" };
const _hoisted_2 = { class: "flex min-h-screen items-center justify-center px-6 py-8" };
const _hoisted_3 = { class: "w-full rounded-lg border bg-white shadow md:max-w-md" };
const _hoisted_4 = { class: "text-xl font-semibold text-gray-900" };
const _hoisted_5 = {
    for: "new-password",
    class: "block text-sm font-medium text-gray-900"
};
const _hoisted_6 = {
    for: "confirm-password",
    class: "block text-sm font-medium text-gray-900"
};
const _hoisted_7 = {
    for: "email",
    class: "block text-sm font-medium text-gray-900"
};
const _hoisted_8 = ["disabled"];
const _hoisted_9 = {
    href: "/login",
    class: "block text-center text-sm font-medium text-primary-600 hover:underline"
};
import { computed, onMounted, reactive, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import api from "@/infrastructure/api/axios";
export default /*@__PURE__*/ _defineComponent({
    ...{ name: "AuthPasswordReset" },
    __name: 'PasswordReset',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const { t } = useI18n();
        const form = reactive({ email: "", newPassword: "", confirmPassword: "" });
        const loading = ref(false);
        const error = ref(false);
        const message = ref("");
        // Kept in memory only: the grant is scrubbed from the address bar as soon as it is read.
        const accessGrant = ref("");
        const recoveryId = computed(() => typeof route.params.recoveryId === "string" ? route.params.recoveryId : "");
        const isCompletion = computed(() => !!recoveryId.value);
        function readAccessGrant(hash) {
            const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
            return params.get("access-grant") ?? "";
        }
        function showError(key) {
            error.value = true;
            message.value = t(key);
        }
        onMounted(() => {
            if (!isCompletion.value)
                return;
            accessGrant.value = readAccessGrant(window.location.hash);
            // The access grant is a single-use capability token carried only in the URL fragment of the
            // recovery email link. Remove it from the address bar once read, preserving history.state
            // (Vue Router keeps its navigation bookkeeping there).
            window.history.replaceState(window.history.state, "", window.location.pathname + window.location.search);
            if (!accessGrant.value)
                showError("shell.auth.password_reset.invalid_link");
        });
        async function submit() {
            if (loading.value)
                return;
            if (isCompletion.value && !accessGrant.value) {
                showError("shell.auth.password_reset.invalid_link");
                return;
            }
            if (isCompletion.value && form.newPassword !== form.confirmPassword) {
                showError("shell.auth.password_reset.password_mismatch");
                return;
            }
            loading.value = true;
            error.value = false;
            message.value = "";
            try {
                if (isCompletion.value) {
                    await api.patch(`/api/v2/password-recoveries/${encodeURIComponent(recoveryId.value)}`, { newPassword: form.newPassword }, { headers: { "X-Access-Grant": accessGrant.value } });
                    message.value = t("shell.auth.password_reset.complete_success");
                    router.push("/login");
                }
                else {
                    await api.post("/api/v2/password-recoveries", { email: form.email });
                    message.value = t("shell.auth.password_reset.request_success");
                }
            }
            catch {
                showError("shell.auth.password_reset.error");
            }
            finally {
                loading.value = false;
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("form", {
                            class: "space-y-4 p-6",
                            onSubmit: _withModifiers(submit, ["prevent"])
                        }, [
                            _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)(`shell.auth.password_reset.${isCompletion.value ? "complete_title" : "request_title"}`)), 1),
                            (isCompletion.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(t)("shell.auth.password_reset.new_password")), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "new-password",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.newPassword) = $event)),
                                        name: "newPassword",
                                        type: "password",
                                        autocomplete: "new-password",
                                        minlength: "8",
                                        required: "",
                                        class: "block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-gray-900"
                                    }, null, 512), [
                                        [_vModelText, form.newPassword]
                                    ]),
                                    _createElementVNode("label", _hoisted_6, _toDisplayString(_unref(t)("shell.auth.password_reset.confirm_password")), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "confirm-password",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.confirmPassword) = $event)),
                                        name: "confirmPassword",
                                        type: "password",
                                        autocomplete: "new-password",
                                        minlength: "8",
                                        required: "",
                                        class: "block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-gray-900"
                                    }, null, 512), [
                                        [_vModelText, form.confirmPassword]
                                    ])
                                ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("shell.auth.password_reset.email")), 1),
                                    _withDirectives(_createElementVNode("input", {
                                        id: "email",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.email) = $event)),
                                        name: "email",
                                        type: "email",
                                        autocomplete: "email",
                                        required: "",
                                        class: "block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-gray-900"
                                    }, null, 512), [
                                        [_vModelText, form.email]
                                    ])
                                ], 64)),
                            (message.value)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 2,
                                    class: _normalizeClass(error.value ? 'text-red-500' : 'text-green-600')
                                }, _toDisplayString(message.value), 3))
                                : _createCommentVNode("", true),
                            _createElementVNode("button", {
                                type: "submit",
                                disabled: loading.value,
                                class: "w-full rounded-lg bg-eorange-400 px-5 py-2.5 text-sm font-medium text-white disabled:opacity-60"
                            }, _toDisplayString(_unref(t)(`shell.auth.password_reset.${loading.value ? "loading" : isCompletion.value ? "complete" : "request"}`)), 9, _hoisted_8),
                            _createElementVNode("a", _hoisted_9, _toDisplayString(_unref(t)("shell.auth.password_reset.back_to_login")), 1)
                        ], 32)
                    ])
                ])
            ]));
        };
    }
});
